import { render } from "./InventoryNewDialog.vue?vue&type=template&id=3378c0e9"
import script from "./InventoryNewDialog.vue?vue&type=script&lang=js"
export * from "./InventoryNewDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__